export default {
  'component.sellersorders.title': "Selgers bestillinger",
  'component.sellersorders.description':
    'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes.',
  'component.sellersorders.line1.button1': 'tilbake',
};
